// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postPaymentCaseDocument } from 'services/PaymentsService'
import { logSentryError } from 'utils/sentry'

export const useUploadPaymentCaseDocumentMutation = () => {
  return useMutation({
    mutationFn: postPaymentCaseDocument,
    onError: (error, data) => {
      logSentryError('Error: useUploadPaymentCaseDocumentMutation', error, data)
    },
  })
}
